import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../config";

const Address = ({ selectedAddress, onSuccess, onCancel }) => {
  const [form, setForm] = useState({
    street: "",
    city: "",
    state: "",
    zip: "",
  });

  useEffect(() => {
    if (selectedAddress) {
      setForm(selectedAddress);
    }
  }, [selectedAddress]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (selectedAddress) {
        await axios.put(`${BASE_URL}/addresses/${selectedAddress.id}`, form);
      } else {
        await axios.post(`${BASE_URL}/addresses`, form);
      }
      onSuccess();
    } catch (error) {
      console.error("Error saving address:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        name="street"
        value={form.street}
        onChange={handleChange}
        placeholder="Street"
      />
      <input
        name="city"
        value={form.city}
        onChange={handleChange}
        placeholder="City"
      />
      <input
        name="state"
        value={form.state}
        onChange={handleChange}
        placeholder="State"
      />
      <input
        name="zip"
        value={form.zip}
        onChange={handleChange}
        placeholder="ZIP Code"
      />
      <button type="submit">
        {selectedAddress ? "Update" : "Add"} Address
      </button>
      {onCancel && (
        <button type="button" onClick={onCancel}>
          Cancel
        </button>
      )}
    </form>
  );
};

export default Address;
